// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/departure-procedure-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/departure-procedure-types/departure-procedure-types.js';

mount([g0]);
